import LeadConfigurations from './LeadConfigurations';

export default LeadConfigurations;
